__turbopack_context__.v({
  "container": "_4DoVxa_container",
  "decorator": "_4DoVxa_decorator",
  "error": "_4DoVxa_error",
  "fieldset": "_4DoVxa_fieldset",
  "legend": "_4DoVxa_legend",
  "medium": "_4DoVxa_medium",
  "small": "_4DoVxa_small",
});
